<template>
    <transition name="cred-result">
        <div v-if="lastTest"
            ref="root"
            class="cred-result"
            :class="lastTest.ok ? 'is-ok' : 'is-error'"
            :role="lastTest.ok ? 'status' : 'alert'"
            tabindex="-1">
            <span class="cred-result-icon" aria-hidden="true">
                <fa :icon="lastTest.ok ? 'check' : 'exclamation-triangle'" />
            </span>

            <div class="cred-result-body">
                <strong class="cred-result-title">
                    {{lastTest.ok ? 'Conexão funcionando' : 'O teste de conexão falhou'}}
                    <span class="cred-result-time">às {{lastTest.at}}</span>
                </strong>

                <p v-if="lastTest.ok">O Muven conseguiu falar com o canal usando estas credenciais.</p>

                <template v-else>
                    <p>Resposta do canal: <code>{{lastTest.message}}</code></p>
                    <p class="cred-result-hint">Confira se copiou as credenciais inteiras e sem espaços. Se a loja estiver fora do ar ou bloqueando o acesso, você pode salvar mesmo assim e testar depois.</p>

                    <div class="cred-result-actions" v-if="saveAnyway">
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('review')">
                            Revisar credenciais
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger" :disabled="saving" @click="$emit('save-anyway')">
                            <fa icon="sync-alt" spin v-if="saving" />
                            {{saving ? 'Salvando' : 'Salvar mesmo assim'}}
                        </button>
                    </div>
                </template>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * Resultado do último "Testar conexão", na própria tela (o aviso flutuante some
 * antes de a pessoa terminar de ler a resposta do canal).
 */
export default {
    name: 'ChannelCredentialsTestResultCmp',
    props: {
        // { ok, message, at }
        lastTest: {
            type: Object,
            default: null,
        },
        // Mostra "Salvar mesmo assim" quando o teste falha
        saveAnyway: {
            type: Boolean,
            default: false,
        },
        saving: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        focus() {
            const root = this.$refs.root

            if (root) {
                root.scrollIntoView({ behavior: 'smooth', block: 'center' })
                root.focus({ preventScroll: true })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
$ease-out: cubic-bezier(.22, 1, .36, 1);

.cred-result {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 20px;
    padding: 14px 16px;
    border: 1px solid;
    border-radius: 12px;
    outline: none;

    &.is-ok {
        border-color: var(--success-border);
        background: var(--success-bg);
        color: var(--success-fg);
    }

    &.is-error {
        border-color: var(--danger-border);
        background: var(--danger-bg);
        color: var(--danger-fg);
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 25%, transparent);
    }
}

.cred-result-icon {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--surface-1);
    font-size: 13px;
}

.cred-result-body {
    flex: 1 1 auto;
    min-width: 0;

    p {
        margin: 4px 0 0;
        font-size: 14px;
        line-height: 1.45;
    }

    code {
        padding: 1px 6px;
        border-radius: 4px;
        background: var(--surface-1);
        color: inherit;
        font-size: 13px;
        word-break: break-word;
    }
}

.cred-result-title {
    display: block;
    font-size: 15px;
}

.cred-result-time {
    margin-left: 4px;
    font-weight: 500;
    opacity: .8;
}

.cred-result-hint {
    color: var(--text-soft);
}

.cred-result-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;

    .btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: var(--surface-1);
    }
}

.cred-result-enter-active {
    transition: opacity .3s $ease-out, transform .3s $ease-out;
}

.cred-result-enter {
    opacity: 0;
    transform: translateY(-6px);
}

@media (prefers-reduced-motion: reduce) {
    .cred-result-enter-active {
        transition: none;
    }
}
</style>
